import { render, staticRenderFns } from "./JiaBie.vue?vue&type=template&id=685b40f6&scoped=true&"
import script from "./JiaBie.vue?vue&type=script&lang=js&"
export * from "./JiaBie.vue?vue&type=script&lang=js&"
import style0 from "./JiaBie.vue?vue&type=style&index=0&id=685b40f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685b40f6",
  null
  
)

export default component.exports